<template>
	<div>
		<!-- <div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div> -->
		<div class="query">
			
			<div>
				<Select v-model="query.paixu" placeholder="排序方式" style="width: 200px;"  filterable='true'  @on-change="onchangeSousuo2">
					    <Option value="1">注册时间</Option>
				        <Option value="2">使用次数降序</Option>
						<Option value="3">使用金额降序</Option>
				</Select>
			<!-- 	<Select v-model="query.allianceId"   style="width:200px"  filterable='true' clearable='true' @on-change="onchangeSousuo1">
				        <Option v-for="(item,i) in alliances" :value="item.id" :key="i">{{item.id}}-{{item.companyName}}</Option>
				</Select>
				<Select v-model="query.addressIds"  placeholder="请选择设备"   style="width:200px" max-tag-count='3' multiple='true' filterable='true' clearable='true' @on-change="onchangeSousuo2">
				        <Option v-for="(item,i) in address" :value="item.id" :key="i">{{item.id}}-{{item.address}}</Option>
				</Select> -->
			</div>
			<Input search enter-button placeholder="id/微信名称/手机号" v-model="query.like" style="width: 500px;" @on-search="onsearch"/>
		</div>
		<Table border :columns="columns12" :data="data6"  :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				<!-- <Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">修改</Button>-->
				<!-- <Button type="primary" size="small" style="margin-right: 5px" @click="toudijilu(row)">投递情况</Button> -->
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				address:[],
				loading:false,
				total: 0,
				query: {//查询参数
					page: 0,
					size: 10,
					like:'',
					addressIds:[],
					allianceId:null,
					paixu:'1'
				},
				alliances:[],
				columns12: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: 'id',
						key: 'id',
						width:120,
						align: 'center',
					}, {
						title: '微信头像',
						key: 'wechatImg',
						width:150,
						align: 'center',
						render: (h, params) => {
							const row = params.row;
							
							if(params.row.wechatImg!=null && params.row.wechatImg!=""){
								return h('div', [
									h('img', {
										style: {
											width: "100px",
											height:'100px',
											verticalAlign: "middle"
										},
										attrs: {
											src: params.row.wechatImg
										}
									}, )
								]);
							}else{
								return h("div","")
							}
						}
						
					}, {
						title: '微信名称',
						key: 'wechatName',
						width:150,
						align: 'center',
					},  {
						title: '头像',
						key: 'elseImg',
						width:150,
						align: 'center',
						render: (h, params) => {
							const row = params.row;
							
							if(params.row.elseImg!=null && params.row.elseImg!=""){
								return h('div', [
									h('img', {
										style: {
											width: "100px",
											height:'100px',
											verticalAlign: "middle"
										},
										attrs: {
											src: params.row.elseImg
										}
									}, )
								]);
							}else{
								return h("div","")
							}
						}
						
					},{
						title: '昵称',
						key: 'elseName',
						width:120,
						align: 'center',
					},{
						title: '手机号',
						key: 'phone',
						width:150,
						align: 'center',
					},{
						title: '消费金额',
						key: 'money',
						width:120,
						align: 'center',
						render: (h, params) => {
							return h("div",params.row.money/100)
							
						}
					},{
						title: '使用次数',
						key: 'number',
						width:120,
						align: 'center',
					},{
						title: '小捷积分',
						key: 'integral',
						width:120,
						align: 'center',
					},{
						title: '小程序次数',
						key: 'appletNumber',
						width:150,
						align: 'center',
					},{
						title: 'app次数',
						key: 'appNumber',
						width:120,
						align: 'center',
					},
					{
						title: '录入时间',
						key: 'createdTime',
						width:150,
						align: 'center',
					},
					{
						title: '操作',
						slot: 'action',
						width: 200,
						align: 'center'
					}
				],
				data6: [
				/* 	{
					id: '1',
					companyName: '',
					address: '',
					phone1: '',
					phone2: '',
					phone3: '',
					mailbox: '',
					operType: '',
					state: '',
					createdTime: '2010-10-10'

				}, */
				]

			}
		},
		methods: {
			onsearch(){
				this.query.page=0
				this.ajaxPage();
			},
			onchangeSousuo1(){
				this.query.page=0
				
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.ajaxPage()
				this.queryAddress()
			},
			onchangeSousuo2(){
				this.query.page=0
				
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.ajaxPage()
			},
			setRegion(regionId){
				this.query.regionIds=regionId
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				this.ajaxPage();
				console.log(this.query.regionId)
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			
			forbidden(id){
				this.deleteId=id
				this.modal2=true
			},
			
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			toudijilu(item){
					this.$router.push({
						name:'jm/lajiguanli/toufang/list',
						query:{clientCode:item.id}
					})
			},
			queryAddress() {
				this.loading = true
				
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/jm',
				    data:  {
						page: 0,
						size: 1000,
						allianceId:_this.query.allianceId
					},
					_this:_this,
					success: function(data) {
					  
					  _this.address = data.macLeaveFactorys.content
					  console.log(_this.address)
					  _this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			queryAlliance() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/alliance/page1',
				    data: {
						page:0,
						size:1000
					},
					_this:_this,
					success: function(data) {
					  _this.alliances = data.alliances.content
					  
					  _this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/client/page',
				    data: _this.query,
					_this:_this,
					success: function(data) {
					  _this.total = data.page.totalElements
					  _this.data6 = data.page.content
					  
					  _this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}

		},
		components: {
			page
		},
		created() {
			let _this=this
			let addressId=this.$route.query.addressId;
			let allianceId=this.$route.query.allianceId;
				_this.query.allianceId=allianceId
			
			
			this.ajaxPage()
			this.queryAlliance()
			if(allianceId!=null){
			_this.query.addressId.push(addressId)
				this.queryAddress()
			}
		}


	}
</script>
<style scoped="scoped">
	.ivu-table-cell{
		padding-left: 0px!important;
	}
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.ivu-table-cell {
		padding-left: 0px;
	}
	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/client/list.vue